import frame from "./frame1.png";
import bg from "./bg.png";

const Frames = [frame, bg];
export default Frames;
